module.exports = __webpack_public_path__ + "static/media/ichor.a74507e3.png";